import * as React from "react";
import { useLoaderData } from 'react-router-dom';
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Header from "../components/Header";
import { listElephants } from "../models/elephants";
import { listAssessments } from "../models/assessments";
import { listChanges } from "../models/changes";
import { listUsers } from "../models/users";

import {useMessage} from "../context/MessageProvider";


import {FormProvider} from '../components/form/FormProvider';
import FormOnChange from '../components/form/FormOnChange';
import FormTextField from '../components/form/FormTextField';
import FormButton from '../components/form/FormButton';
import FormDropDown from '../components/form/FormDropDown';

import { date } from "../utils/datetime";

import { supabase } from '../lib/supabase'

import { fetchAssessmentExportDataByElephantId } from "../models/assessments";
import { zip } from "../utils/zip";
import { downloadBlob } from "../utils/download";

import { assessmentCsvList } from "../utils/assessments";

export async function loader() {
  const elephants = await listElephants();
  const users = await listUsers();
  const assessments = await listAssessments();
  const changes = await listChanges();
  return { elephants, assessments, changes, users};
}


const downloadPdf = async (pdfBase64) => {
  try {

    const binary = atob(pdfBase64);
    const len = binary.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    const url = window.URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'report.pdf'); // Set default filename
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Download failed:', error);
  }
};


export default function ReportingPage({ title = "Reporting", ...props }) {

  const { elephants, assessments, users } = useLoaderData();
  const {setSuccess, setError} = useMessage();

  //const {inProgressObservations, current, clearObservations, startClipboardMode} = useSectionB();

  const [working,setWorking] = React.useState(false);

  const onSubmit = async(inputData) => {
    try {
      console.log("onSubmit data: ", inputData);
      setWorking(true);


      if (inputData?.output_type === "pdf-base64") {
        const result = await supabase.functions.invoke('assessment-report',{body: {assessment_id: inputData.assessment_id, output: inputData.output_type, previous_assessments_to_include: inputData.previous_assessments_to_include || 4}});
        downloadPdf(result.data);
        console.log("function result", result);
      } else if (inputData?.output_type === "csv") {

        console.log("csv export");
        const data = await fetchAssessmentExportDataByElephantId(inputData.elephant_id, inputData.previous_assessments_to_include);
        console.log("csv data", data);
        const fileData = assessmentCsvList({assessments: data, elephants, users});
        const zipData = zip(fileData);
        const zipBlob = new Blob([zipData], {type: "application/zip"});
        downloadBlob({blob: zipBlob, filename: "assessment_data.zip"});
      }

      setSuccess("Report Done");
    } catch (error) {
      console.error(error);
      setError(error.message);
    } finally {
      setWorking(false);
    }
  }


  const completedAssessments = assessments.filter((cur) => {
    return cur.submitted_on !== null;
  });

  completedAssessments.sort((a, b) => {
    if (a.submitted_on.isBefore(b.submitted_on)) {
      return 1
    } else if (a.submitted_on.isAfter(b.submitted_on)) {
      return -1
    } else {
      return 0;
    }
  });

  console.log("completed assessment count", completedAssessments.length);
  const [elephantAssessments, setElephantAssessments] = React.useState([]);

  const onChange = async(inputData) => {
    console.log("onChange ", inputData);

    const tempList = completedAssessments.filter((cur) => {
      return cur.elephant_id === inputData.elephant_id;
    }).map((cur)=>{
      console.log(cur);
      return {
        value: cur.id,
        label: "Assessment Started " + date(cur.started_on) + ", Submitted " + date(cur.submitted_on),
      };
    })
    setElephantAssessments(tempList);

  }



  const elephantList = elephants.map((cur) => {
    return {
      value: cur.id,
      label: cur.name,
    };
  });

  const defaultValues = {
    elephant_id: '',
    assessment_id: '',
    previous_assessments_to_include: 4,
    output_type: "pdf-base64",
  }

  // how many into the past to get?
  // select which assessments to include?
  // report output type?

  return (
  <Container component="main" maxWidth="md">
    <Header label={title} />

      <FormProvider onSubmit={onSubmit} onChange={onChange} defaultValues={defaultValues} >
        <FormOnChange>
            <Grid container spacing={2}>
                <Grid xs={12}>
                    <FormDropDown name="elephant_id" label="Elephant" list={elephantList} required/>
                </Grid>

                <Grid xs={12}>
                    <FormDropDown name="assessment_id" label="Assessments" list={elephantAssessments} required/>
                </Grid>

                <Grid xs={12}>
                  <FormTextField name="previous_assessments_to_include" label="Previous Assessments To Include" rules={{ pattern: {
                      value: /^[0-9]+$/,
                      message: "Only whole numbers are allowed",
                    }
                  }} required/>
                </Grid>

                <Grid xs={12}>
                    <FormDropDown name="output_type" label="Output Type" list={[{value: "pdf-base64", label: "PDF"}, {value: "csv", label: "CSV"}]} required/>
                </Grid>

                <Grid xs={12}>
                    <FormButton working={working}>Submit</FormButton>
                </Grid>
            </Grid>
        </FormOnChange>
    </FormProvider>
  </Container>
  );
}
